import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import css from '../../node_modules/@styled-system/css/dist/index.esm.js';
import React__default from 'react';
import styled, { useTheme } from 'styled-components';
import '../../node_modules/styled-system/dist/index.esm.js';
import { useMergeRefs } from '../../hooks/useMergeRefs.js';
import { Box } from '../layout/Box.js';
import '../layout/Stack.js';
import '../layout/AnimatedBox.js';
import '../layout/Scrollbars.js';
import { InputWrapper } from './InputWrapper.js';
import { Label } from './Label.js';
import { color } from '../../node_modules/@styled-system/color/dist/index.esm.js';
import { space } from '../../node_modules/@styled-system/space/dist/index.esm.js';
var StyledInput = styled.input(function (_a) {
  var hasLabel = _a.hasLabel;
  return css({
    boxSizing: "border-box",
    padding: "0",
    paddingTop: hasLabel ? "4px" : undefined,
    border: "0",
    appearance: "none",
    outline: "none",
    fontSize: "paragraph.md",
    letterSpacing: "sm",
    fontFamily: "matter",
    color: "textPrimary",
    width: "100%",
    backgroundColor: "unset",
    "::placeholder": {
      opacity: hasLabel ? 0 : 1,
      transition: "opacity 300ms ease",
      color: "grey.2"
    },
    ":focus::placeholder": {
      opacity: 1
    }
  });
}, color, space);
var Input = React__default.forwardRef(function (_a, ref) {
  var onChange = _a.onChange,
    isInvalid = _a.isInvalid,
    onFocus = _a.onFocus,
    onBlur = _a.onBlur,
    _borderColor = _a.borderColor,
    backgroundColor = _a.backgroundColor,
    rest = __rest(_a, ["onChange", "isInvalid", "onFocus", "onBlur", "borderColor", "backgroundColor"]);
  var defaultValue = rest.defaultValue,
    value = rest.value,
    label = rest.label,
    disabled = rest.disabled;
  var _b = React__default.useState(false),
    isFocused = _b[0],
    setIsFocused = _b[1];
  var _c = React__default.useState(false),
    hasValue = _c[0],
    setHasValue = _c[1];
  var inputRef = React__default.useRef(null);
  var mergedRef = useMergeRefs(inputRef, ref);
  var theme = useTheme();
  var borderColor = _borderColor ? css({
    color: _borderColor
  })(theme).color : undefined;
  React__default.useEffect(function () {
    if (defaultValue || value) {
      setHasValue(true);
    }
  }, [defaultValue, value]);
  var handleClick = function handleClick() {
    var _a;
    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
  };
  var handleFocus = React__default.useCallback(function (e) {
    setIsFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
  }, [onFocus]);
  var handleBlur = React__default.useCallback(function (e) {
    var _a;
    setIsFocused(false);
    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
    onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
  }, [onBlur]);
  var handleChange = React__default.useCallback(function (e) {
    if (e.target.value.length > 0) {
      setHasValue(true);
    } else {
      setHasValue(false);
    }
    onChange === null || onChange === void 0 ? void 0 : onChange(e);
  }, [onChange]);
  return React__default.createElement(InputWrapper, {
    as: "label",
    onClick: handleClick,
    backgroundColor: backgroundColor || "base",
    borderColor: borderColor,
    isDisabled: disabled,
    isFocused: isFocused,
    isInvalid: isInvalid,
    position: "relative"
  }, React__default.createElement(Box, {
    paddingY: "8px"
  }, label && React__default.createElement(Label, {
    isFocused: isFocused,
    hasValue: hasValue,
    isDisabled: disabled,
    isInvalid: isInvalid
  }, label), React__default.createElement(StyledInput, __assign({}, rest, {
    hasLabel: !!label,
    onFocus: handleFocus,
    ref: mergedRef,
    onBlur: handleBlur,
    onChange: handleChange,
    "aria-invalid": isInvalid
  }))));
});
export { Input };